import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, formatPattern } from '../../utils';
import { setLastPreselectedDevice } from '../app/actions';
import { fetchDeviceForMeter, onAddOrEditDeviceModalIsLoading, onAddOrEditDeviceModalIsShown } from '../homes/actions';

const onDevicesListIsLoading = isLoading => ({
    type: CONSTANTS.ON_DEVICE_LIST_IS_LOADING,
    payload: { isLoading }
});

const onDeviceList = data => ({
    type: CONSTANTS.ON_DEVICE_LIST,
    payload: { data }
});

// ========= THUNKS ============

/**
 * fetchAllDevices
 * - Fetching all devices
 * @since 2.7.0
 *
 *
 * @returns {Promise}
 */
export const fetchAllDevices = (meterId, deleted = false) => (dispatch, getState) => {
    const devicesState = getState().devices.get('list');
    if (devicesState.get('isLoading')) return;
    dispatch(onDevicesListIsLoading(true));

    return api(formatPattern(
        deleted ? REQUEST_URL.DEVICE_FOR_METER_ID : REQUEST_URL.DEVICE_LIST, {meterId}
    ), METHOD.GET, null, {}, !deleted)
        .then(res => {
            // console.log(res.body);
            if (res && res.ok) {
                dispatch(onDeviceList(fromJS(res.body)));
                const devs = res.body.length > 0 ? res.body.filter(item => !item.deleted) : [];
                dispatch(setLastPreselectedDevice(devs.length > 0 ? devs[0].device : undefined));
                dispatch(onDevicesListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onDevicesListIsLoading(false));
            throw err;
        });
};
